import React from 'react';

import { Text } from '@reckon-web/text';
import { LoadingDots } from '@reckon-web/loading';

import { useGetUser } from '../../../data/useGetUser';
import { GetActivityItem } from '../../../data/useGetActivities';
import { nameStatus } from '../../../utils/name-status-utils';

interface IActivityCategorySignOffRequest {
  activity: GetActivityItem;
}

// ActivityCategory SignOffRequest = 8
export const ActivityCategorySignOffRequest = ({
  activity,
}: IActivityCategorySignOffRequest) => {
  const userCloudId = !activity.propertyNew ? '' : activity.propertyNew;

  const { data, loading, error } = useGetUser({
    variables: { cloudId: userCloudId },
  });

  if (loading) {
    return <LoadingDots size="small" label="Loading sign off request" />;
  }

  if (error || !data) {
    return (
      <Text size="small" color="critical">
        Error
      </Text>
    );
  }

  return <Text size="small">Requested sign off from {nameStatus(data)}</Text>;
};
